module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-single element-non-bodymatter element-type-also-by element-with-heading",
    attrs: {
      "id": "also-by"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "also-by-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Books in The Circuit Fae Series By Genevieve Iseult Eldredge")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "also-by-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "http://www.fireflyhillpress.com/moribund",
      "target": "_blank"
    }
  }, [_vm._v("Moribund - Book 1")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "http://www.firelfyhillpress.com/derailed",
      "target": "_blank"
    }
  }, [_vm._v("Derailed - Novella 1.5")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "http://www.fireflyhillpress.com/ouroboros",
      "target": "_blank"
    }
  }, [_vm._v("Ouroboros - Book 2")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "http://www.fireflyhillpress.com/dethroned",
      "target": "_blank"
    }
  }, [_vm._v("Dethroned - Novella  2.5")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "http://www.fireflyhillpress.com/inimical",
      "target": "_blank"
    }
  }, [_vm._v("Inimical - Book 3")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "http://www.fireflyhillpress.com/rekindled",
      "target": "_blank"
    }
  }, [_vm._v("Rekindled - Novella 3.5")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "http://www.fireflyhillpress.com/nemesis",
      "target": "_blank"
    }
  }, [_vm._v("Nemesis - Book 4")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "http://www.fireflyhillpress.com/eidolon",
      "target": "_blank"
    }
  }, [_vm._v("Eidolon - Book 5")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd7ca626","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booksinthecircuitfaeseriesbygenevieveiseulteldredge.vue
// module id = 66
// module chunks = 0